import React, { Component } from 'react'

import { TextField, Typography } from '@material-ui/core'
import CustomNumberFormat from '../components/custom_number_format'

import EurasianLogo from '../img/eurasian_logo.png'
import MogoLogo from '../img/mogo_logo.png'
import KmfLogo from '../img/KMF_logo.png'
import ShfLogo from '../img/SHF_logo.png'
import BccLogo from '../img/bcc_logo.png'
import RglLogo from '../img/rgl_logo.png'

class CalcPrint extends Component {
  constructor() {
    super()
    this.state = {
      bank: ''
    }
  }
  componentDidMount() {
    this.setState({ bank: JSON.parse(localStorage.getItem('printData')).bank })
  }
  render() {
    const { bank } = this.state
    const { carPrice, initialPaymentAmount, calcBank } = JSON.parse(
      localStorage.getItem('printData')
    )

    return (
      <div>
        <div id="calc" className="calc">
          <div className="calc__left">
            <div className="calcPaper calcPaperLeft">
              <img
                onLoad={() => window.print()}
                src={
                  bank === 'kmf'
                    ? KmfLogo
                    : bank === 'evraz'
                    ? EurasianLogo
                    : bank === 'shf'
                    ? ShfLogo
                    : bank === 'bcc'
                    ? BccLogo
                    : bank === 'mogo'
                    ? MogoLogo
                    : bank === 'rgl' && RglLogo
                }
                alt="bank logo"
              />
              <div style={{ marginTop: '10px' }}>Стоимость авто</div>
              <TextField
                variant="outlined"
                value={carPrice}
                InputProps={{
                  inputComponent: CustomNumberFormat,
                  className: 'textfield_green'
                }}
              />
              <div style={{ marginTop: '10px' }}>Первоначальный взнос</div>
              <TextField
                variant="outlined"
                value={initialPaymentAmount}
                InputProps={{
                  inputComponent: CustomNumberFormat,
                  className: 'textfield_green'
                }}
              />
              <div className="CCInputLabel">Сумма займа</div>
              <div className="CCTakeResult">
                {(carPrice - initialPaymentAmount)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}
              </div>
            </div>
          </div>

          <div className="calc__right">
            {calcBank.map(calc => (
              <div className="calcPaper calcPaperRight">
                <Typography
                  variant="h4"
                  align="center"
                  gutterBottom
                  style={{ color: '#EF311F' }}
                >
                  {calc.months / 12}{' '}
                  {calc.months / 12 === 1
                    ? 'год'
                    : calc.months / 12 > 4
                    ? 'лет'
                    : 'года'}
                </Typography>
                <div>
                  <div className="CCInputLabel">Ежемесячный платеж</div>
                  <div className="CCTakeResult">
                    {calc.monthlyPayment
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}
                  </div>
                </div>
                <div>
                  <div className="CCInputLabel">Переплата</div>
                  <div className="CCTakeResult">
                    {calc.overPayment
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  }
}

export default CalcPrint
